import { css } from '@emotion/react';
import { tokens } from '../../tokens';
/** Used _internally_ only, to help with mapping fallback values for light theme.
 * @see lightThemeStyle for external usage */
export const INTERNAL_LIGHT_MODE_MAPPING = {
    '--wf-bg--active': tokens.colors.grey10,
    '--wf-bg--contrast': tokens.colors.white,
    '--wf-bg--contrast-inverse': tokens.colors.navy,
    '--wf-bg--focus': tokens.colors.grey6,
    '--wf-bg--hover': tokens.colors.grey6,
    '--wf-bg--hover-strong': tokens.colors.grey10,
    '--wf-bg--hover-strong-inverse': tokens.colors.white20,
    '--wf-bg--main': tokens.colors.greySubtle,
    '--wf-bg--overlay': tokens.colors.navy70,
    '--wf-bg--secondary': tokens.colors.greyLight,
    '--wf-bg--tertiary': tokens.colors.grey,
    '--wf-bg--transparent': tokens.colors.grey10,
    '--wf-bg--transparent-inverse': tokens.colors.white20,
    '--wf-blue--darker': tokens.colors.blueDark,
    '--wf-blue--lighter': tokens.colors.blueLight,
    '--wf-blue--main': tokens.colors.blue,
    '--wf-blue--text': tokens.colors.blueDarkText,
    '--wf-blue--text-on-color': tokens.colors.navy,
    '--wf-blue--transparent': tokens.colors.blueDark12,
    '--wf-border-color--focus-outline': tokens.colors.blueDark,
    '--wf-border-color--interactive': tokens.colors.grey60,
    '--wf-border-color--main': tokens.colors.grey15,
    '--wf-border-color--strong': tokens.colors.grey30,
    '--wf-box-shadow--medium': '0px 1px 4px -1px rgba(48, 57, 105, 0.3)',
    '--wf-box-shadow--thick': '0px 3px 5px -1px rgba(48, 57, 105, 0.3)',
    '--wf-box-shadow--thin': '0px 0px 2px 0px rgba(48, 57, 105, 0.3)',
    '--wf-box-shadow--xthick': '0px 8px 12px -4px rgba(48, 57, 105, 0.3)',
    '--wf-brand--darker': tokens.colors.greenDark,
    '--wf-brand--lighter': tokens.colors.greenLight,
    '--wf-brand--main': tokens.colors.green,
    '--wf-brand--text': tokens.colors.navy,
    '--wf-brand--text-on-color': tokens.colors.navy,
    '--wf-brand--text-subtle': tokens.colors.grey60,
    '--wf-error--darker': tokens.colors.redDark,
    '--wf-error--lighter': tokens.colors.redLight,
    '--wf-error--main': tokens.colors.red,
    '--wf-error--text': tokens.colors.redDarkText,
    '--wf-error--text-on-color': tokens.colors.white,
    '--wf-error--transparent': tokens.colors.red10,
    '--wf-green--darker': tokens.colors.greenDark,
    '--wf-green--lighter': tokens.colors.greenLight,
    '--wf-green--main': tokens.colors.green,
    '--wf-green--text': tokens.colors.greenDarkText,
    '--wf-green--text-on-color': tokens.colors.navy,
    '--wf-green--transparent': tokens.colors.greenLight20,
    '--wf-grey--darker': tokens.colors.greyMedium,
    '--wf-grey--lighter': tokens.colors.greyLight,
    '--wf-grey--main': tokens.colors.grey,
    '--wf-grey--subtler': tokens.colors.greySubtle,
    '--wf-grey--text': tokens.colors.greyDark,
    '--wf-grey--text-on-color': tokens.colors.navy,
    '--wf-grey--transparent': tokens.colors.grey10,
    '--wf-info--darker': tokens.colors.blueDark,
    '--wf-info--lighter': tokens.colors.blueLight,
    '--wf-info--main': tokens.colors.blue,
    '--wf-info--text': tokens.colors.blueDarkText,
    '--wf-info--text-on-color': tokens.colors.navy,
    '--wf-info--transparent': tokens.colors.blue20,
    '--wf-navy--darker': tokens.colors.navyDark,
    '--wf-navy--lighter': tokens.colors.navyMedium,
    '--wf-navy--main': tokens.colors.navy,
    '--wf-navy--subtler': tokens.colors.navyLight,
    '--wf-navy--text': tokens.colors.navy,
    '--wf-navy--text-on-color': tokens.colors.white,
    '--wf-navy--transparent': tokens.colors.navy10,
    '--wf-orange--darker': tokens.colors.orangeDark,
    '--wf-orange--lighter': tokens.colors.orangeLight,
    '--wf-orange--main': tokens.colors.orange,
    '--wf-orange--text': tokens.colors.orangeDarkText,
    '--wf-orange--text-on-color': tokens.colors.navy,
    '--wf-orange--transparent': tokens.colors.orange20,
    '--wf-pink--darker': tokens.colors.pinkDark,
    '--wf-pink--lighter': tokens.colors.pinkLight,
    '--wf-pink--main': tokens.colors.pink,
    '--wf-pink--text': tokens.colors.pinkDarkText,
    '--wf-pink--text-on-color': tokens.colors.navy,
    '--wf-pink--transparent': tokens.colors.pinkLight18,
    '--wf-purple--darker': tokens.colors.purpleDark,
    '--wf-purple--lighter': tokens.colors.purpleLight,
    '--wf-purple--main': tokens.colors.purple,
    '--wf-purple--text': tokens.colors.purpleDarkText,
    '--wf-purple--text-on-color': tokens.colors.white,
    '--wf-purple--transparent': tokens.colors.purple18,
    '--wf-red--darker': tokens.colors.redDark,
    '--wf-red--lighter': tokens.colors.redLight,
    '--wf-red--main': tokens.colors.red,
    '--wf-red--text': tokens.colors.redDarkText,
    '--wf-red--text-on-color': tokens.colors.white,
    '--wf-red--transparent': tokens.colors.red18,
    '--wf-success--darker': tokens.colors.greenDark,
    '--wf-success--lighter': tokens.colors.greenLight,
    '--wf-success--main': tokens.colors.green,
    '--wf-success--text': tokens.colors.greenDarkText,
    '--wf-success--text-on-color': tokens.colors.navy,
    '--wf-success--transparent': tokens.colors.green10,
    '--wf-text--inverse': tokens.colors.white,
    '--wf-text--inverse-subtle': tokens.colors.navySubtleTextOnDark,
    '--wf-text--link': tokens.colors.blueDarkText,
    '--wf-text--main': tokens.colors.navy,
    '--wf-text--secondary': tokens.colors.navyLight,
    '--wf-text--subtle': tokens.colors.navySubtleTextOnLight,
    '--wf-transparent-grey--darker': tokens.colors.grey30,
    '--wf-transparent-grey--lighter': tokens.colors.grey15,
    '--wf-transparent-grey--main': tokens.colors.grey20,
    '--wf-transparent-grey--subtler': tokens.colors.grey10,
    '--wf-transparent-grey--text': tokens.colors.greyDarkText,
    '--wf-transparent-grey--text-on-color': tokens.colors.navy,
    '--wf-upgrade--darker': tokens.colors.purpleDark,
    '--wf-upgrade--lighter': tokens.colors.purpleLight,
    '--wf-upgrade--main': tokens.colors.purple,
    '--wf-upgrade--text': tokens.colors.purpleDarkText,
    '--wf-upgrade--text-on-color': tokens.colors.white,
    '--wf-upgrade--transparent': tokens.colors.purple10,
    '--wf-warning--darker': tokens.colors.orangeDark,
    '--wf-warning--lighter': tokens.colors.orangeLight,
    '--wf-warning--main': tokens.colors.orange,
    '--wf-warning--text': tokens.colors.orangeDarkText,
    '--wf-warning--text-on-color': tokens.colors.navy,
    '--wf-warning--transparent': tokens.colors.orange20,
    '--wf-white--main': tokens.colors.white,
    '--wf-white--text': tokens.colors.white,
    '--wf-white--text-on-color': tokens.colors.navy,
    '--wf-white--transparent': tokens.colors.white20,
    '--wf-yellow--darker': tokens.colors.yellowDark,
    '--wf-yellow--lighter': tokens.colors.yellowLight,
    '--wf-yellow--main': tokens.colors.yellow,
    '--wf-yellow--text': tokens.colors.yellowDarkText,
    '--wf-yellow--text-on-color': tokens.colors.navy,
    '--wf-yellow--transparent': tokens.colors.yellowLight20,
};
export const lightThemeStyle = css([
    { colorScheme: 'light' },
    INTERNAL_LIGHT_MODE_MAPPING,
]);
